import { render, staticRenderFns } from "./TgDateSearch.vue?vue&type=template&id=e517c0a6"
import script from "./TgDateSearch.vue?vue&type=script&lang=js"
export * from "./TgDateSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports